import { ScenarioRuns } from '@/features/decisions/components/backtests/ScenarioRuns';

export function BacktestDetail() {
  return <ScenarioRuns />;
}
